/**
 * Created by contrapro on 07/11/2017
 */

export const pointTypes = {

    //登录单向同步CRM积分
    SYNC_CRM_POINT_LOGIN:{
        type: 'SYNC_CRM_POINT_LOGIN',
        // point: ,
        remark: '许愿池登录单向同步CRM积分',
        // limitNum: 1,
        // limitMall: ''
    },

    //微信分享朋友圈，sy暂时只有下方光点分享才送分。
    // SHARE_WECHAT:{
    //     type: 'SHARE_WECHAT',
    //     point: 20,
    //     remark: '都市农庄微信分享',
    //     limitNum: 5, //每日限领5次
    //     limitMall: '02' //指定武汉才能领
    // },

    //MGM拉一个会员注册，给介绍人送分，sy暂时没有
    // MGM_INVITE:{
    //     type: 'MGM_INVITE',
    //     point: 300,
    //     remark: '都市农庄微信MGM',
    //     limitNum: 5, //每日限领5次
    //     limitMall: '02' //指定武汉才能领
    // },

    //注册，点礼乐园注册获得500积分，sy游戏不再送
    // NEW_REGISTER:{
    //     type: 'NEW_REGISTER',
    //     point: 400,
    //     remark: '都市农庄首次游戏',
    //     limitNum: 1,
    //     limitMall: ''
    // },

    //给愿望助力
    POWER_WISH:{
        type: 'POWER_WISH',
        point: 10,
        remark: '许愿池助力',
        // limitNum: 1, //每日限额
        // limitMall: '' //限定某商场
    },
    //光点-问卷
    LIGHT_QA:{
        type: 'LIGHT_QA',
        point: 100,
        remark: '许愿池光点问卷答题',
        // limitNum: 1, //每日限额
        // limitMall: '' //限定某商场
    },
    //光点-抽奖 //抽中积分得50，抽中奖品不再得积分
    LIGHT_LOTTERY:{
        type: 'LIGHT_LOTTERY',
        point: 50,
        remark: '许愿池光点抽奖积分',
        limitNum: 1, //每日限额
        // limitMall: '' //限定某商场
    },
    //光点-箴言分享
    LIGHT_SOUP_SHARE:{
        type: 'LIGHT_SOUP_SHARE',
        point: 200,
        remark: '许愿池光点箴言分享',
        limitNum: 1, //每日限领5次
        limitMall: '01' //指定沈阳才能领 TODO: 沈阳商场ID? SY01
    },
    //光点-释放
    LIGHT_RELEASE:{
        type: 'LIGHT_RELEASE',
        point: 10,
        remark: '许愿池光点释放',
        // limitNum: 1, //每日限额
        // limitMall: '' //限定某商场
    },

    //许愿，消耗积分
    MAKE_WISH:{
        type: 'MAKE_WISH',
        // point: 1000, //做成非固定，Server端配置表决定，目前所有愿望都是消耗100, price 100
        remark: '许愿池许愿', //若有需要区分，则remark=许愿池许愿+wishType
        // limitNum: 1, //每日限额
        // limitMall: '' //限定某商场
    },

    // //购买种子
    // BUY_SEED:{
    //     type: 'BUY_SEED',
    //     // point: ,
    //     remark: '都市农庄购买种子',
    //     // limitNum: 1,
    //     // limitMall: ''
    // },
    // //完成5种种子种植，有7000分bonus奖励
    // FINISH_5_FREESEED_PLANT:{
    //     type: 'FINISH_5_FREESEED_PLANT',
    //     point: 7000,
    //     remark: '都市农庄收集5种植物',
    //     limitNum: 1,
    //     limitMall: ''
    // },

};



// WEBPACK FOOTER //
// ./src/util/pointConfig.js